module.exports = __webpack_public_path__ + "img/seta_rosa.a7d35d28.svg";